export default __webpack_public_path__ + "static/lmstudio-86fcef6197d814c8c508a1bc010d41d6.png";